import { toNativePromise } from '../../commonInfra/utils/QUtils';
import { IListFetcher } from '../fetchers/IListFetcher';
import { Filter } from '../helpers/Filter';
import { ILeafFilterClause } from '../ServerApi/types/IFilterClause';
import { NamedItemKeys } from '../ServerApi/types/resourceParts';
import { FieldValuesQuery } from './FieldValuesQuery';
import { IResourceQuery, ResourceQuery } from './ResourceQuery';

export interface IListResource<T> {
  all(): IResourceQuery<T>;
}

export interface IDetailResource<T> {
  getById(id: string): Promise<T>;
}

export interface IActionResource<T> {
  actions(id: string): ng.IPromise<T>;
}

export interface IFieldValuesResource {
  valuesForField(field: string): FieldValuesQuery;
}

export type IListAndFieldValuesResource<T> = IListResource<T> & Partial<IFieldValuesResource>;

/**
 * @deprecated Implement the interfaces IListResource<T> or IDetailResource instead. See `Views.ts` for an example
 */
export class Resource<T> implements IListResource<T>, IDetailResource<T> {

  private fetcher: IListFetcher<T>;
  private allQuery: ResourceQuery<T>;

  constructor(fetcher: IListFetcher<T>) {
    this.fetcher = fetcher;
    this.allQuery = new ResourceQuery(this.fetcher);
  }

  public all(): ResourceQuery<T> {
    return this.allQuery;
  }

  public getById(id: string, additionalFilterClauses?: ILeafFilterClause[]): Promise<T> {
    let query = this.all();
    if(additionalFilterClauses) query = query.withFilters(additionalFilterClauses);
    return toNativePromise(
      query.addFilter(Filter.stringFieldEq(NamedItemKeys.id, id))
           .getFirst()
    );
  }

}
